export const FILTER_TYPE = {
  INSTITUTION: 'institution_ids',
  NAME: 'name',
  STATUS: 'status',
};
